import React from "react";
import {useParams} from "react-router-dom";
import useSWR, {mutate} from "swr";

import {AXIOS} from "../../services/api";
import { Loader } from "../../components";

import {EmptyStore} from "./components/EmptyStore";
import {ApplicationDetail} from "./components/ApplicationDetail";

function ApplicationDetailPage() {
    const [storeLinked, setStoreLinked] = React.useState(false);
    const {applicationId} = useParams();
    const {data, isLoading, error} = useSWR(`applications/${applicationId}`, AXIOS.get);

    const application = data?.data?.data || {};
    const isEmptyApplication = Object.keys(application).length === 0;
    const stores = React.useMemo(() => application.stores || [], [application.stores]);

    React.useEffect(() => {
        setStoreLinked(stores.length > 0);
    }, [stores]);

    React.useEffect(() => {
        if (storeLinked) {
            mutate(`applications/${applicationId}`);
        }
    }, [storeLinked, applicationId]);

    if (isLoading) {
        return <Loader loading={isLoading} />
    }

    if (error) {
        return <div>Error fetching data</div>;
    }

    return (
        <>
            {
                isEmptyApplication ? (
                    <div>Application not found</div>
                ) : (
                    !storeLinked ? (
                        <EmptyStore application={application} onStoreLinked={() => setStoreLinked(true)}/>
                    ) : (
                        <ApplicationDetail application={application}/>
                    )
                )
            }
        </>
    );
}

export {ApplicationDetailPage};
